import { render, staticRenderFns } from "./ganhuo-collection.vue?vue&type=template&id=207d19f8&scoped=true&"
import script from "./ganhuo-collection.vue?vue&type=script&lang=js&"
export * from "./ganhuo-collection.vue?vue&type=script&lang=js&"
import style0 from "./ganhuo-collection.scss?vue&type=style&index=0&id=207d19f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207d19f8",
  null
  
)

export default component.exports